export default __webpack_public_path__ + "static/thyroid-box@2x-d41b90b720b69b6f9320029359ab6710.png";